import React from "react";

interface Props {
  setModalOption: any;
  setNodeToAdd: any;
  graphData: any;
  nodeToAdd: any;
  setGraphData: any;
  drawCircle: any;
}

export const AddNodeModule: React.FC<Props> = ({
  setModalOption,
  setNodeToAdd,
  graphData,
  nodeToAdd,
  setGraphData,
  drawCircle,
}) => {
  const addNode = (node: any) => {
    let nodesArray: any = graphData["nodes"];

    setModalOption("General Information");
    setGraphData({
      ...graphData,
      nodes: graphData["nodes"].concat({
        id: nodesArray.length,
        index: nodesArray.length,
        canvas: drawCircle(),
        description: node.desription || "",
        name: node.name,
        label: node.name,
      }),
    });
  };

  return (
    <div className="p-4">
      <div className="">
        <div className="grid grid-cols-3">
          <button
            onClick={() => setModalOption("General Information")}
            className="col-span-1 w-1/3 hover:cursor-pointer  hover:bg-blue-600 bg-blue-500 rounded-lg  text-white shadow-md py-1 px-3 flex flex-row font-semibold text-center  justify-center items-center space-x-1 "
          >
            {" "}
            X
          </button>

          <div className="font-bold text-lg col-span-2 ">Add Node</div>
        </div>
        <div className="">
          <form className="my-1">
            <label
              className="block text-xs font-bold mb-2"
              htmlFor="grid-password"
            >
              Name
            </label>
            <input
              value={nodeToAdd.name}
              placeholder="Write a name here..."
              onChange={(e) =>
                setNodeToAdd({ ...nodeToAdd, name: e.target.value })
              }
              maxLength={40}
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </form>
          <div className="py-2  bg-white rounded-b-lg ">
            <label
              className="block text-xs font-bold mb-2"
              htmlFor="grid-password"
            >
              Description
            </label>
            <textarea
              id="editor"
              rows={15}
              onChange={(e) =>
                setNodeToAdd({
                  ...nodeToAdd,
                  description: e.target.value,
                })
              }
              maxLength={2000}
              value={
                nodeToAdd.description !== "" ||
                nodeToAdd.desciption !== undefined
                  ? nodeToAdd.description
                  : ""
              }
              placeholder={"Node Information goes here"}
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            ></textarea>
          </div>
          <button
            onClick={() => addNode(nodeToAdd)}
            className="my-2 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full "
          >
            {" "}
            Add Node
          </button>
        </div>
      </div>
    </div>
  );
};
